import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-sky-100 bg-white px-4 py-12" data-id="element-158" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-159" data-mp="32nummremu92y">
        <p className="text-lg font-black uppercase tracking-tight text-primary" data-id="element-160" data-mp="32pfeg99kbdx4">
          💪 Combo Completo Fortalecimiento Lumbar 2026
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-161" data-mp="3ufa4y995p9nd">
          El sistema de recuperación y protección de espalda para personas en Argentina que quieren
          vivir sin miedo al dolor lumbar.
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-500" data-id="element-162" data-mp="3levg4zwzhcf4">
          Porque tu espalda no debería limitarte la vida.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-slate-600 sm:flex-row sm:gap-6" data-id="element-163" data-mp="3qc44ji8q6cot">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="mailto:compradigitalyaa@gmail.com" data-id="element-164" data-mp="2a1ji55nwno0v">
            <MailIcon className="h-4 w-4" data-id="element-165" data-mp="3lbdces4h47la" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-166" data-mp="3gcaa3ffvofh0">
            <GlobeIcon className="h-4 w-4" data-id="element-167" data-mp="828qmgkzanef" /> www.compradigitalya.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://instagram.com/compradigitalya" target="_blank" rel="noopener noreferrer" data-id="element-168" data-mp="34gvldp1el60">
            <InstagramIcon className="h-4 w-4" data-id="element-169" data-mp="cvtlhzr9z19e" /> @compradigitalya
          </a>
        </div>
        <div className="mt-7 border-t border-sky-100 pt-6" data-id="element-170" data-mp="qrf9c3lrvf08">
          <p className="text-base font-black text-ink" data-id="element-171" data-mp="msy27k2cq4it">💪 “El próximo día puede ser diferente.”</p>
          <p className="mt-1 text-sm font-semibold italic text-primary" data-id="element-172" data-mp="tw5yw7u65sn9">
            “Finalmente una mañana sin pensar en mi espalda”
          </p>
          <p className="mt-5 text-xs font-semibold text-slate-400" data-id="element-173" data-mp="yrv00flu7hlo">
            © CompraDigitalYa™ 2026 — Todos los derechos reservados.
            <br data-id="element-174" data-mp="18k959ic4j6cl" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}